module.exports = __webpack_public_path__ + "img/1-02.7ccd224f.png";